import { AuthHttpRepository } from "@/features/auth/repository";
import { UsersHttpRepository } from "@/features/users/repository";
import { ThemesHttpRepository } from "@/features/themes/repository";
import { DilemmasHttpRepository } from "@/features/dilemmas/repository";
import { QuestionsHttpRepository } from "@/features/questions/repository";
import { AnswersHttpRepository } from "@/features/answers/repository";
import { HistoriesHttpRepository } from "@/features/history/repository";
import { AboutHttpRepository } from "@/features/about/repository";
import { DocsHttpRepository } from "@/features/docs/repository";
import { AlertsHttpRepository } from "@/features/alerts/repository";
import { SettingsHttpRepository } from "@/features/settings/repository";
import { StatsHttpRepository } from "@/features/stats/repository";
import { AiWritingAssistantHttpRepository } from "@/features/ai-writing-assistant/repository";

export const authRepo = new AuthHttpRepository();
export const usersRepo = new UsersHttpRepository();
export const themesRepo = new ThemesHttpRepository();
export const dilemmasRepo = new DilemmasHttpRepository();
export const questionsRepo = new QuestionsHttpRepository();
export const answersRepo = new AnswersHttpRepository();
export const historiesRepo = new HistoriesHttpRepository();
export const aboutRepo = new AboutHttpRepository();
export const docsRepo = new DocsHttpRepository();
export const alertsRepo = new AlertsHttpRepository();
export const settingsRepo = new SettingsHttpRepository();
export const statsRepo = new StatsHttpRepository();
export const aiWritingAssistantRepo = new AiWritingAssistantHttpRepository();
